import { render, staticRenderFns } from "./SignupHeader.vue?vue&type=template&id=3249d945&scoped=true"
import script from "./SignupHeader.vue?vue&type=script&lang=ts"
export * from "./SignupHeader.vue?vue&type=script&lang=ts"
import style0 from "./SignupHeader.vue?vue&type=style&index=0&id=3249d945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3249d945",
  null
  
)

export default component.exports